import React, { useEffect, useRef } from "react";

const VideoPopUp = () => {
  const videoEl = useRef(null);
  const handleClose = () => {
    const modal = document.getElementById("exampleModalToggle");
    modal.style.display = "none";
    modal.classList.remove("show");
  };
  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch((error) => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <div
    className="popup"
    id="exampleModalToggle"
    aria-labelledby="exampleModalToggleLabel"
    tabIndex="-1"
    aria-hidden="true"
  >
    <div
      className="modal show"
      id="exampleModalToggle"
      tabIndex="-1"
      aria-labelledby="exampleModalToggleLabel"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <div className="modal-dialog ">
        <div className="modal-content">
        <div id="modalH" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                {/* Close Button */}
                <button
  type="button"
  className="btn-close"
  onClick={handleClose}
  aria-label="Close"
></button>

                {/* Modal Content */}
                <div className="modal-body">
                  <div className="card modalcard mb-0">
                    <div className="card-body">
                      {/* Video */}
                      <video
                        style={{
                          maxWidth: "100%",
                          width: "100%",
                          margin: "0 auto",
                          height: "600px",
                          maxHeight: "80%",
                          background: "#000",
                        }}
                        playsInline
                        loop
                        muted
                        controls
                        alt="All the devices"
                        src="https://webapi.entab.info/api/image/AFGJI/public/Images/newYearVideo.mp4"
                        ref={videoEl}
                      />
                      {/* Message */}
                      <p className="text-center mt-3" style={{height: "auto", display: "block"}}>
                        SPECIAL WING, STUDENTS AND STAFF OF AFGJI 
                        WISHES YOU A HAPPY NEW YEAR
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default VideoPopUp;
